import { DatePipe, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import {
  BehaviorSubject,
  animationFrameScheduler,
  combineLatest,
  interval,
} from 'rxjs';
import {
  distinctUntilChanged,
  endWith,
  map,
  switchMap,
  takeWhile,
} from 'rxjs/operators';
import { TipoBeneficio } from '../../_models/Enums/tipoExperiencia';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { NumberPipe } from '../../_shared/pipes/number.pipe';

registerLocaleData(localePt, 'pt');

const animation = { duration: 30000, easing: (t) => t };
const easeOutQuad = (x: number): number => x * (2 - x);

const ID_CONTEUDO_STORIES = 7;
const ID_CONTEUDO_DEPOIMENTOS = 8;

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  providers: [NumberPipe],
})
export class LandingPageComponent implements OnInit, AfterViewInit {
  private animatedElements: string[] = [
    'container-somos',
    'container-value',
    'cta-title',
    'cta-description-title',
    'cta-description',
    'cta-button',
    'experiencias-title',
    'disposition-title',
    'disposition-description',
    'conclusion-text',
    'conclusion-button',
    'video-player',
    'disposition-feliz-hoje',
    'disposition-hashtag',
    'disposition-hashtag-2',
    'conclusion-description',
    'beneficios-1',
    'beneficios-2',
    'beneficios-3',
    'comments',
  ];

  windowWidth: number = window.innerWidth;
  width: number = window.innerWidth;

  membro: any = undefined;

  public idStatus: number = 0;
  public token: string = '';

  public experiencias: any[][] = [];
  public experiencia: any;
  exibirPopupImg: boolean = false;

  // Lovers pela causa
  public experienciasCausa: any[] = [];
  public quantidadeCards: number = 0;
  private readonly TIPOS_EXPERIENCIA: any = `[${TipoBeneficio.Promocao},${TipoBeneficio.Experiencia},${TipoBeneficio.ComResgateDeProdutos}]`;
  private readonly TIPOS_EXPERIENCIA_LP: any = `[${TipoBeneficio.Promocao},${TipoBeneficio.Beneficio},${TipoBeneficio.Experiencia},${TipoBeneficio.ComResgateDeProdutos}]`;
  private readonly MIN_VALUE_CACAUS: number = 0;
  private readonly MAX_VALUE_CACAUS: number = 150;
  public minValue: number = this.MIN_VALUE_CACAUS;
  public maxValue: number = this.MAX_VALUE_CACAUS;
  public carregandoCards: boolean = false;

  public idLoteExperiencia: number = 0;
  public idExperiencia: number = 0;

  slideIndex: number = 1;
  currentSlide: number = 0;
  slider: KeenSliderInstance = null;

  sliderExperiencias: KeenSliderInstance = null;
  experienciasPerView: number = 6;
  exibirCarouselExperiencias: boolean = true;

  stories: string[] = [];
  storiesMobile: string[] = [];

  exibirModalCadastro: boolean = false;
  exibirModalLogin: boolean = false;
  exibirModalEsqueciSenha: boolean = false;

  depoimentos: string[] = [];
  depoimentosMobile: string[] = [];

  // Contador de membros ativos
  contador = new BehaviorSubject(0);
  duracao = new BehaviorSubject(5000);

  cadastroRealizado: boolean = false;

  // Imagem aleatória
  randomImageUrl: SafeResourceUrl;

  hashIndicacao: string = '';
  sessao_app: string = '';
  appOnly: boolean = false;
  origem: number = 0;
  linkRedirect: string = '';
  etapaLogin: number;
  returnUrl: string = '';

  @ViewChild('footercontent', { static: true }) appFooter: ElementRef;

  private readonly contagemAtual = combineLatest([
    this.contador,
    this.duracao,
  ]).pipe(
    switchMap(([contador, duracao]) => {
      const startTime = animationFrameScheduler.now();

      return interval(0, animationFrameScheduler).pipe(
        map(() => animationFrameScheduler.now() - startTime),
        map((tempoRestante) => tempoRestante / duracao),
        takeWhile((progress) => progress <= 1),
        map(easeOutQuad),
        map((progress: any) => Math.round(progress * contador)),
        endWith(contador),
        distinctUntilChanged()
      );
    })
  );

  quantidadeLovers: any[] = [];

  private contadorSubscribe(): void {
    this.contagemAtual.subscribe((valorAtual) => {
      let valorAtualFormatado = this.numberPipe.transform(valorAtual);

      const valorFinal = [];
      for (let i = 0; i < valorAtualFormatado.length; i++) {
        const valor: string = valorAtualFormatado[i].toString();

        let contadorValor = {
          valor: valor,
          tipo: 'numero',
        };

        if (valor === '.') contadorValor.tipo = 'separador';

        valorFinal.push(contadorValor);
      }

      this.quantidadeLovers = valorFinal;
    });
  }

  constructor(
    private fidelidadeService: FidelidadeService,
    private elRef: ElementRef,
    private numberPipe: NumberPipe,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private authService: AuthService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.hashIndicacao) {
        this.hashIndicacao = params.hashIndicacao;
        this.controlePopupCadastro(true);
      }

      if (params.app) {
        if (params.app == 'true') {
          this.fidelidadeService.LocalStorage.salvarObjetoLocal(
            'sessao_app',
            true
          );
        }
      }

      if (params.origem) {
        this.origem = params.origem;
        this.controlePopupCadastro(true);
      }

      if (params.redirectLink) this.linkRedirect = atob(params.redirectLink);

      if (params.returnUrl) this.returnUrl = params.returnUrl;

      if (params.login) {
        this.controlePopupLogin(true);
      }

      if (params.cadastro) {
        this.controlePopupCadastro(true);
      }

      if (params.tipoStatus) {
        this.exibirModalLogin = true;
        this.carregarImagemAleatoria();
        this.etapaLogin = 4;
      }
    });
    this.carregarMomentosLoversPelaCausa();
    this.obterExperienciasLP();
    this.iniciarContador();
    this.obterStories();
    this.obterDepoimentos();
    if (this.router.url.includes('programa')) this.carregarMembroLogado();
  }

  private carregarMembroLogado(): void {
    var membro = this.authService.LocalStorage.obterMembro();
    this.processarSucessoObterMembro(membro);
  }

  private processarSucessoObterMembro(res: any): void {
    this.membro = res;
  }

  private processarFalhaObterMembro(err: any): void {
    console.log(err);
    console.error('Ocorreu um erro ao obter o membro', err);
  }

  obterStories() {
    this.fidelidadeService
      .obterDescontosParaLovers(ID_CONTEUDO_STORIES)
      .subscribe({
        next: (res: any) =>
          this.processarSucessoObterConteudo(res, ID_CONTEUDO_STORIES),
        error: (err: any) => this.processarFalhaObterConteudo(err),
      });
  }

  obterDepoimentos() {
    this.fidelidadeService
      .obterDescontosParaLovers(ID_CONTEUDO_DEPOIMENTOS)
      .subscribe({
        next: (res: any) =>
          this.processarSucessoObterConteudo(res, ID_CONTEUDO_DEPOIMENTOS),
        error: (err: any) => this.processarFalhaObterConteudo(err),
      });
  }

  processarSucessoObterConteudo(res: any, idTipoDesconto: number) {
    const imagens: string[] = [];
    const imagensMobile: string[] = [];

    res.forEach((conteudo: any) => {
      imagens.push(conteudo.caminhoImagem);
      imagensMobile.push(conteudo.caminhoImagemMobile);
    });

    if (idTipoDesconto === ID_CONTEUDO_STORIES) {
      this.stories = imagens;
      this.storiesMobile = imagensMobile;

      setTimeout(() => {
        this.renderizarStories();
      }, 50);
    }

    if (idTipoDesconto === ID_CONTEUDO_DEPOIMENTOS) {
      this.depoimentos = imagens;
      this.depoimentosMobile = imagensMobile;
    }
  }

  processarFalhaObterConteudo(err: any) {
    console.error('Um erro ocorreu ao obter os stories', err);
  }

  controlePopupLogin(exibir: boolean) {
    this.exibirModalLogin = exibir;
    this.carregarImagemAleatoria();
  }

  controlePopupCadastro(exibir: boolean) {
    this.exibirModalCadastro = exibir;
    this.carregarImagemAleatoria();
  }

  controlePopupEsqueci(exibir: boolean) {
    this.exibirModalEsqueciSenha = exibir;
    this.carregarImagemAleatoria();
  }

  abrirAcessoPeloCadastro() {
    this.exibirModalCadastro = false;
    this.exibirModalLogin = true;
  }

  abrirAcessoPeloEsqueci() {
    this.exibirModalEsqueciSenha = false;
    this.exibirModalLogin = true;
  }

  receberIdStatus(event: number) {
    this.idStatus = event;
  }

  receberToken(event: string) {
    this.token = event;
  }

  abrirCadastroPeloAcesso() {
    this.exibirModalLogin = false;
    this.exibirModalCadastro = true;
  }

  abrirEsqueciMinhaSenhaPeloAcesso() {
    this.exibirModalLogin = false;
    this.exibirModalEsqueciSenha = true;
  }

  irParaPaginaPromocoes() {
    this.router.navigate(['/promocao']);
  }

  private iniciarContador(): void {
    this.contadorSubscribe();
    this.obterTotalMembros();
  }

  private obterTotalMembros(): void {
    this.fidelidadeService.obterTotalMembrosAtivos().subscribe({
      next: (res: any) => this.processarSucessoObterTotalMembrosAtivos(res),
      error: (err: any) => this.processarFalhaObterTotalMembrosAtivos(err),
    });
  }

  private processarSucessoObterTotalMembrosAtivos(res: any): void {
    this.contador.next(res);
  }

  private processarFalhaObterTotalMembrosAtivos(err: any): void {
    console.error(
      'Ocorreu um erro ao obter a quantidade de membros ativos no programa',
      err
    );
    this.contador.next(26000000);
  }

  private obterExperienciasLP(): void {
    var filtroExperiencia: any = {
      tipos: this.TIPOS_EXPERIENCIA_LP,
      niveis: this.obterFiltroNiveis(),
      estados: this.obterFiltroEstados(),
      campanhas: this.obterFiltroCampanhas(),
      ordem: this.obterFiltroOrdemDestaque(),
      categorias: '',
      descricao: '',
      rangeCacaus: this.obterFiltroRange(),
      somenteAtivos: true,
      pagina: 'lp',
      ehTelaMomentoEspecial: false,
    };

    this.fidelidadeService.searchExperiencias(filtroExperiencia).subscribe({
      next: (res: any) => this.processarSucessoObterExperiencias(res),
      error: (err: any) => this.processarFalhaObterExperiencias(err),
    });
  }

  private processarSucessoObterExperiencias(res: any): void {
    res = res.resultado;

    if (res.length % 2 !== 0) res.pop();

    this.splitExperiencias(res);
  }

  private splitExperiencias(res: any): void {
    let splitQtd: number = 2;

    if (this.windowWidth <= 460) splitQtd = 3;

    const experiencias = [];
    for (var i = 0; i < res.length; i = i + splitQtd) {
      experiencias.push(res.slice(i, i + splitQtd));
    }

    this.experiencias = experiencias;

    this.exibirCarouselExperiencias = true;

    setTimeout(() => {
      this.renderExperienciasCarousel();
    }, 50);
  }

  private processarFalhaObterExperiencias(err: any): void {
    console.error('Um erro ocorreu ao obter as experiências da LP', err);
  }

  ngAfterViewInit() {
    const widthSize = window.innerWidth;
    this.resizeExperienciasPerView(widthSize);
    setTimeout(() => {
      this.aplicarPropriedadeCSS();
    }, 1000);
  }

  aplicarPropriedadeCSS() {
    if (this.appFooter != undefined) {
      // Aplicar a propriedade CSS ao elemento
      this.renderer.setStyle(this.appFooter.nativeElement, 'display', 'none');
    }
  }

  nextStory() {
    let index = this.currentSlide;

    if (index === this.stories.length - 1) index = 0;
    else index += 1;

    this.slider.moveToIdx(index);
    this.currentSlide = index;
  }

  previousStory() {
    let index = this.currentSlide;

    if (index === 0) index = this.stories.length - 1;
    else index -= 1;

    this.slider.moveToIdx(index);
    this.currentSlide = index;
  }

  goToStory(i: number) {
    this.currentSlide = i;
    this.slider.moveToIdx(i);
  }

  onCadastroRealizado(): void {
    this.cadastroRealizado = !this.cadastroRealizado;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event): void {
    // Exibir/ocultar/travar botão de voltar ao topo
    const clientViewHeight: number = document.documentElement.clientHeight;
    const scrollHeight: number = window.scrollY + clientViewHeight;

    const carouselHeight =
      document.getElementById('carousel-contents').scrollHeight;

    const scrollToTopElement = document.getElementById('go-to-top');

    const showElementAt = carouselHeight + 116;

    if (scrollHeight > showElementAt)
      scrollToTopElement?.classList.add('go__top--show');
    else scrollToTopElement?.classList.remove('go__top--show');

    const documentHeight = document.body.scrollHeight;
    const elementMoveUpAt = documentHeight - 160;

    if (scrollHeight > elementMoveUpAt) {
      const footerHeight = 180;
      const styles = getComputedStyle(scrollToTopElement);
      const buttonBottom = Number(styles.bottom.replace('px', ''));

      let buttonFinalBottom = footerHeight + buttonBottom;
      buttonFinalBottom = buttonFinalBottom > 220 ? 220 : buttonFinalBottom;

      scrollToTopElement.style.bottom = buttonFinalBottom + 'px';
    } else scrollToTopElement.style.bottom = '24px';

    // Exibir elemento caso esteja na visão do usuário
    for (let i = 0; i < this.animatedElements.length; i++) {
      const element = document.getElementById(this.animatedElements[i]);
      const resetAnimationClass: string = 'initial__state__animation';

      if (
        element === null ||
        !this.checkIfElementInViewport(element) ||
        element.classList.contains(resetAnimationClass)
      )
        continue;

      element.classList.add(resetAnimationClass);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.width = window.innerWidth;
    const widthSize = event.target.innerWidth;
    if (widthSize !== this.windowWidth) this.windowWidth = widthSize;
    this.resizeExperienciasPerView(widthSize);
  }

  resizeExperienciasPerView(size: number) {
    let perView: number = 3;

    if (size > 1900) {
      perView = 7;
    }
    if (size <= 1899) {
      perView = 5;
    }
    if (size <= 900) {
      perView = 3;
    }
    if (size <= 480) {
      perView = 2.65;
    }

    if (this.experiencias.length > 0) {
      const res: any[] = [];
      this.experiencias.forEach((experiencia: any) => {
        experiencia.forEach((exp: any) => {
          res.push(exp);
        });
      });
      this.splitExperiencias(res);
    }

    if (this.experienciasPerView === perView) return;

    this.experienciasPerView = perView;

    setTimeout(() => {
      this.renderizarStories();
      this.renderExperienciasCarousel();
    }, 50);
  }

  private checkIfElementInViewport(el: any): boolean {
    const rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  private renderExperienciasCarousel(): void {
    const element = <HTMLElement>(
      this.elRef.nativeElement.querySelector('#sliderExperienciasRef')
    );

    this.sliderExperiencias = new KeenSlider(
      element,
      {
        loop: true,
        initial: 0,
        slides: {
          perView: this.experienciasPerView,
        },
      },
      [
        (slider) => {
          let timeout;
          let mouseOver = false;
          function clearNextTimeout() {
            clearTimeout(timeout);
          }
          function nextTimeout() {
            clearTimeout(timeout);
            if (slider.slides.length < 2) return;
            if (mouseOver) return;
          }
          slider.on('created', (s) => {
            slider.container.addEventListener('mouseover', () => {
              mouseOver = true;
              clearNextTimeout();
            });
            slider.container.addEventListener('mouseout', () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
            s.moveToIdx(5, true, animation);
          });
          slider.on('dragStarted', clearNextTimeout);
          slider.on('animationEnded', function (s) {
            nextTimeout();
            s.moveToIdx(s.track.details.abs + 5, true, animation);
          });
          slider.on('updated', function (s) {
            nextTimeout();
            s.moveToIdx(s.track.details.abs + 5, true, animation);
          });
        },
      ]
    );
  }

  renderizarStories() {
    const element = <HTMLElement>(
      this.elRef.nativeElement.querySelector('#sliderRef')
    );

    this.slider = new KeenSlider(
      element,
      {
        loop: true,
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel;
        },
      },
      [
        (slider) => {
          let timeout;
          let mouseOver = false;
          function clearNextTimeout() {
            clearTimeout(timeout);
          }
          function nextTimeout() {
            clearTimeout(timeout);

            if (slider.slides.length < 2) return;

            if (mouseOver) return;

            timeout = setTimeout(() => {
              slider.next();
            }, 7000);
          }
          slider.on('created', () => {
            slider.container.addEventListener('mouseover', () => {
              mouseOver = true;
              clearNextTimeout();
            });
            slider.container.addEventListener('mouseout', () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
          });
          slider.on('dragStarted', clearNextTimeout);
          slider.on('animationEnded', nextTimeout);
          slider.on('updated', nextTimeout);
        },
      ]
    );
  }

  tratarCategorias(idCategoria: number): string {
    if (idCategoria == 1) return 'Aventura';
    else if (idCategoria == 2) return 'Esporte e Bem estar';
    else if (idCategoria == 3) return 'Online';
    else if (idCategoria == 4) return 'Entretenimento';
    else if (idCategoria == 5) return 'Gastronomia';
    else if (idCategoria == 6) return 'Viagem/Passeio';
    else if (idCategoria == 8) return 'Social';
    else if (idCategoria == 9) return 'Ativação';
    else {
      idCategoria;
    }
  }

  public irParaOTopo(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  carregarImagemAleatoria() {
    const imageList = [
      'boliche.png',
      'cafe.png',
      'bytes.png',
      'sorvete.png',
      'sorvete2.png',
    ];

    const randomIndex = Math.floor(Math.random() * imageList.length);
    const imagePath = `assets/images/backgrounds/${imageList[randomIndex]}`;

    this.randomImageUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(imagePath);
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  // Lovers pela causa

  public carregarMomentosLoversPelaCausa() {
    this.carregandoCards = true;
    this.experienciasCausa = [];
    var filtroExperiencia: any = {
      tipos: this.TIPOS_EXPERIENCIA,
      niveis: this.obterFiltroNiveis(),
      estados: this.obterFiltroEstados(),
      categorias: this.obterFiltroCategorias(),
      campanhas: this.obterFiltroCampanhas(),
      ordem: this.obterFiltroOrdem(),
      descricao: '',
      rangeCacaus: null,
      somenteAtivos: false,
    };

    this.fidelidadeService.searchExperiencias(filtroExperiencia).subscribe({
      next: (res: any) => {
        this.experienciasCausa = res.resultado;
        this.carregandoCards = true;
        this.quantidadeCards = res.resultado.length;
      },
      error: (err: any) => {
        console.log(err);
        this.carregandoCards = true;
      },
    });
  }

  private obterFiltroNiveis(): string {
    var result = '';
    return result;
  }

  private obterFiltroEstados(): string {
    var result = '';
    return result;
  }

  private obterFiltroCategorias(): string {
    return '[8]';
  }

  private obterFiltroCampanhas(): string {
    return '';
  }

  private obterFiltroOrdem(): string {
    return '';
  }

  private obterFiltroOrdemDestaque(): number {
    return 4;
  }

  private obterFiltroRange(): string {
    const list = [this.minValue, this.maxValue];

    return this.obterString(list);
  }

  private obterString(lista: any): string {
    return '[' + lista.join(',') + ']';
  }

  public irParaPelaCausa() {
    if (!this.membro) {
      this.router.navigate(['/pela-causa']);
    } else {
      this.router.navigate(['/lovers-pela-causa']);
    }
  }

  public irParaMomentosEspeciais() {
    if (!this.membro) {
      const link = '/momentos-especiais?categoria=social';
      this.router.navigate(['/home'], {
        queryParams: {
          redirectLink: btoa(link),
          login: btoa('1'),
        },
      });
    } else {
      this.router.navigate(['/momentos-especiais'], {
        queryParams: { categoria: 'social' },
      });
    }
  }

  abrirPopup(experiencia: any) {
    if (!experiencia?.imagemSrc2 || !experiencia?.imagemSrc3) return;

    if (experiencia?.imagemSrc2 && this.width > 480) {
      const slideTrack = document.querySelector('.slide-track');
      if (slideTrack) {
        slideTrack.classList.add('parar-track');
      }
    }
    if (experiencia?.imagemSrc3 && this.width <= 480) {
      const slideTrack = document.querySelector('.slide-track');
      if (slideTrack) {
        slideTrack.classList.add('parar-track');
      }
    }

    this.exibirPopupImg = true;
    this.experiencia = experiencia;

    this.renderer.addClass(document.body, 'no-scroll');
  }

  fecharPopup() {
    this.exibirPopupImg = false;

    const slideTrack = document.querySelector('.slide-track');
    if (slideTrack) {
      slideTrack.classList.remove('parar-track');
    }

    this.renderer.removeClass(document.body, 'no-scroll');
  }

  formatarData(data: string): string {
    let novaData = new Date(data);
    return this.datePipe.transform(novaData, 'MMMM/y', undefined, 'pt');
  }

  receberBloqueioPopup(event: any) {
    console.log(event)
  }
}
